import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/sean.webp'

export const SeanImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Sean'} />
)
